import { render, staticRenderFns } from "./DaoQiPop.vue?vue&type=template&id=f3b50d88&"
import script from "./DaoQiPop.vue?vue&type=script&lang=js&"
export * from "./DaoQiPop.vue?vue&type=script&lang=js&"
import style0 from "./DaoQiPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports